import {h, Fragment} from "preact"
export default function SubmitButton({ className, text }) {
    return (
        <div className={`ns-autocomplete-submit ns-d-flex ns-justify-content-center ${className}`}>
            <button type="submit" className="ns-act-btn ns-text-align-center ns-w-100">
                {text} 
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="7" viewBox="0 0 26 7" fill="none">
                <path d="M25.7516 3.76038C25.9078 3.60417 25.9078 3.35091 25.7516 3.1947L23.206 0.649112C23.0498 0.492902 22.7965 0.492902 22.6403 0.649112C22.4841 0.805321 22.4841 1.05859 22.6403 1.2148L24.9031 3.47754L22.6403 5.74028C22.4841 5.89649 22.4841 6.14976 22.6403 6.30597C22.7965 6.46218 23.0498 6.46218 23.206 6.30597L25.7516 3.76038ZM25.4688 3.47754L25.4688 3.07754L0.46875 3.07754L0.46875 3.47754L0.46875 3.87754L25.4687 3.87754L25.4688 3.47754Z" fill="white"/>
                </svg>
            </button>
        </div>
    )
}